import {BaseModel} from "../../base/models/base-model.model";
import {ListString} from "../../shared/DTO/listString";
import {Management} from "../../shared/DTO/management";
import * as moment from 'moment';

export class CreateDraftModel extends BaseModel {
  private _articleTypes: ListString;
  private _expirationDate?: moment.Moment;
  private _management: Management;
  /**
   * Draft Name
   */
  private _name: string;
  /**
   * Draft Process Id
   */
  private _processId: string;
  /**
   * Draft Reserved to a specific operator
   */
  private _reserved?: boolean;
  /**
   * Draft Unit
   */
  private _unit: string;

  constructor(articleTypes?: ListString, expirationDate?: moment.Moment, management?: Management, name?: string, processId?: string, reserved?: boolean, unit?: string) {
    super();
    this._articleTypes = articleTypes;
    this._expirationDate = expirationDate;
    this._management = management;
    this._name = name;
    this._processId = processId;
    this._reserved = reserved;
    this._unit = unit;
  }

  get articleTypes(): ListString {
    return this._articleTypes;
  }

  set articleTypes(value: ListString) {
    this._articleTypes = value;
  }

  get expirationDate(): moment.Moment {
    return this._expirationDate;
  }

  set expirationDate(value: moment.Moment) {
    this._expirationDate = value;
  }

  get management(): Management {
    return this._management;
  }

  set management(value: Management) {
    this._management = value;
  }

  get name(): string {
    return this._name;
  }

  set name(value: string) {
    this._name = value;
  }

  get processId(): string {
    return this._processId;
  }

  set processId(value: string) {
    this._processId = value;
  }

  get reserved(): boolean {
    return this._reserved;
  }

  set reserved(value: boolean) {
    this._reserved = value;
  }

  get unit(): string {
    return this._unit;
  }

  set unit(value: string) {
    this._unit = value;
  }
}
